import React from 'react';
import Text from 'react-format-text';
import {
  Header,
  Icon,
  Image,
  Label,
  Popup,
  Segment,
  Statistic,
} from 'semantic-ui-react';

import {
  CustomContainer,
  FollowingBtn,
  FollowingBtnGuide,
  RequiresLogin,
  ShareBtn,
} from '../../common';
import {
  ForumLink,
  PersonaLink,
  SchoolLink,
} from '../../Links';
import {
  formatTimestamp,
} from '../../Utils';

const STYLES = {
  CONTENT_DESKTOP: {
    paddingTop: '7em',
    fontSize: '16pt',
    lineHeight: '1.5em',
  },
  CONTENT_MOBILE: {
    paddingTop: '6em',
    fontSize: '12pt',
    lineHeight: '1.5em',
  },
};

const Statistics = ({ data }: { data: any }) => (
  <div style={{ float: 'right' }}>
    {
      Array.isArray(data) && data.map((r) => (
        <Statistic>
          <Statistic.Value>
            {r.count}
          </Statistic.Value>
          <Statistic.Label>
            {r.description}
            {' '}
            <Image src={r.link} avatar />
          </Statistic.Label>
        </Statistic>
      ))
    }
  </div>
);

const generateOriginalPostPageURL = (
  forumAlias: string,
  pageId: string,
) => `https://www.dcard.tw/f/${forumAlias}/p/${pageId}`;

interface InfoProps {
  authed: boolean;
  isMobile: boolean;
  isFetching: boolean;
  shouldDimAdultContent: boolean;
  data: {
    content: string;
    created_at: string;
    department?: string;
    forum: {
      id: string;
      alias: string;
      name: string;
    };
    gender: 'M' | 'F';
    id: string;
    persona_meta?: {
      id: string;
      nickname?: string;
    };
    reactions?: any[];
    school_meta?: {
      id: string;
      name: string;
    };
    title: string;
    topics?: string[];
  };
}

export default ({
  authed,
  isMobile,
  isFetching,
  shouldDimAdultContent,
  data: {
    content,
    created_at: createdAt,
    department,
    forum,
    gender,
    id,
    persona_meta: persona, // (TODO) -> should be renamed to 'persona'
    reactions,
    school_meta: school, // (TODO) -> should be renamed to 'school'
    title,
    topics,
  },
}: InfoProps) => (
  <CustomContainer>
    <Segment loading={isFetching}>
      {
        authed ? (
          <FollowingBtn
            platform="dcard"
            type="post"
            id={id}
          />
        ) : (
          <FollowingBtnGuide />
        )
      }
      <ShareBtn />
      <ForumLink
        id={forum.id}
      >
        <Header
          as={isMobile ? 'h5' : 'h4'}
          floated="right"
          color="teal"
        >
          {forum.name}
          {' '}
          (
          {forum.alias}
          )
        </Header>
      </ForumLink>
      <CustomContainer>
        {
          !isMobile && (
            <Statistics
              data={reactions}
            />
          )
        }
        <Header
          as={isMobile ? 'h3' : 'h2'}
          floated="left"
        >
          {title}
          <Popup
            trigger={(
              <Header.Subheader
                color="grey"
              >
                <Icon name="calendar outline" />
                <span>{formatTimestamp(createdAt)}</span>
              </Header.Subheader>
            )}
            content="發文時間"
            inverted
          />
          <Popup
            trigger={(
              <Header.Subheader
                color="grey"
              >
                {
                  gender === 'M' ? (
                    <Icon name="male" color="blue" />
                  ) : (
                    <Icon name="female" color="pink" />
                  )
                }
                {
                  school && (
                    <SchoolLink id={school.id}>
                      {school.name}
                      {' '}
                      {department}
                    </SchoolLink>
                  )
                }
                {
                  persona && (
                    <PersonaLink id={persona.id}>
                      {persona.nickname ?? persona.id}
                    </PersonaLink>
                  )
                }
              </Header.Subheader>
            )}
            content="使用者ID"
            inverted
          />
        </Header>
        <p style={isMobile ? STYLES.CONTENT_MOBILE : STYLES.CONTENT_DESKTOP}>
          <RequiresLogin
            dimmed={shouldDimAdultContent}
          >
            <Text>
              {content}
            </Text>
          </RequiresLogin>
          <br />
          <a
            style={{
              color: 'grey',
              fontSize: isMobile ? '10pt' : '12pt',
            }}
            href={generateOriginalPostPageURL(forum.alias, id)}
            target="__blank"
          >
            <Icon name="external share" />
            原文連結
          </a>
        </p>
        {
          Array.isArray(topics) && (
            <Label.Group
              color="purple"
              size={isMobile ? 'mini' : 'small'}
            >
              {topics.map((topic) => (
                <Label>
                  {topic}
                </Label>
              ))}
            </Label.Group>
          )
        }
      </CustomContainer>
    </Segment>
  </CustomContainer>
);
